import { Field } from "react-final-form";
import classNames from "classnames";

import InputText from "@components/Form/InputText";
import {
  composeFormValidators,
  isRequired,
  isAlphaNumeric,
  hasMinLength,
  hasMaxLength,
  isCNP,
  isEmail,
  isPhoneNumber,
  hasMinVal,
  hasMaxVal,
} from "@lib/validations";
import Radio from "@components/Form/Radio";

const INPUT_CLASS = "!max-w-full !min-w-0";

const MainDriverSection = ({ values, isCompany }) => (
  <>
    <div className="">
      <div className="text-[14px] mb-3 font-medium">
        Conducatorul principal al vehiculului{" "}
        <span className="text-red-brand">*</span>
      </div>

      {!isCompany && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
          <div
            className={classNames("flex items-center p-[16px] bg-white", {
              "border border-[#99CE88]":
                values.mainDriverSection?.mainDriver === "owner",
            })}
          >
            <Field
              name="mainDriverSection.mainDriver"
              type="radio"
              value="owner"
              component={Radio}
              label="Acelasi cu proprietarul"
              className={classNames("cursor-pointer w-full mb-0", {
                "pointer-events-none cursor-default":
                  values.mainDriverSection?.mainDriver === "owner",
              })}
              labelClass="font-normal text-[14px]"
            />
          </div>

          <div
            className={classNames("flex items-center p-[16px] bg-white", {
              "border border-[#99CE88]":
                values.mainDriverSection?.mainDriver === "other",
            })}
          >
            <Field
              name="mainDriverSection.mainDriver"
              type="radio"
              value="other"
              component={Radio}
              label="Altul"
              className={classNames("cursor-pointer w-full mb-0", {
                "pointer-events-none cursor-default":
                  values.mainDriverSection?.mainDriver === "other",
              })}
              labelClass="font-normal text-[14px]"
            />
          </div>
        </div>
      )}
    </div>

    {(values.mainDriverSection?.mainDriver === "other" || isCompany) && (
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 bg-white p-[16px] ">
        <div>
          <Field
            name="mainDriverSection.mainDriverData.lastName"
            component={InputText}
            label="Nume"
            required
            placeholder="Introdu numele complet"
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            validate={composeFormValidators(
              isRequired(),
              isAlphaNumeric(),
              hasMaxLength(50)
            )}
          />
        </div>

        <div>
          <Field
            name="mainDriverSection.mainDriverData.firstName"
            component={InputText}
            label="Prenume"
            required
            placeholder="Introdu prenumele complet"
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            validate={composeFormValidators(
              isRequired(),
              isAlphaNumeric(),
              hasMaxLength(50)
            )}
          />
        </div>

        <div>
          <Field
            name="mainDriverSection.mainDriverData.cif"
            component={InputText}
            label="CNP"
            required
            placeholder="Introdu CNP"
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            validate={composeFormValidators(
              isRequired(),
              isCNP(),
              hasMinLength(13),
              hasMaxLength(13)
            )}
          />
        </div>

        <div>
          <Field
            name="mainDriverSection.mainDriverData.email"
            component={InputText}
            type="email"
            label="Email"
            required
            placeholder="Introdu email"
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            validate={composeFormValidators(isRequired(), isEmail())}
          />
        </div>

        <div>
          <Field
            name="mainDriverSection.mainDriverData.phone"
            component={InputText}
            type="tel"
            label="Telefon"
            required
            placeholder="Introdu telefon"
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            validate={composeFormValidators(isRequired(), isPhoneNumber())}
          />
        </div>

        <div>
          <Field
            name="mainDriverSection.mainDriverData.idExpirationDate"
            component={InputText}
            type="number"
            label="An expirare CI/BI"
            required
            placeholder={new Date().getFullYear().toString()}
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            parse={(value) =>
              value?.includes("-")
                ? new Date(value).getFullYear().toString()
                : value
            }
            format={(value) =>
              value?.includes("-")
                ? new Date(value).getFullYear().toString()
                : value
            }
            validate={composeFormValidators(
              isRequired(),
              hasMinVal(new Date().getFullYear()),
              hasMaxLength(4),
              hasMinLength(4)
            )}
          />
        </div>

        <div>
          <Field
            name="mainDriverSection.mainDriverData.driverLicenceDate"
            component={InputText}
            placeholder={new Date().getFullYear().toString()}
            label="An obtinere permis"
            type="number"
            required
            inputClassName={INPUT_CLASS}
            labelClass="text-sm"
            parse={(value) =>
              value?.includes("-")
                ? new Date(value).getFullYear().toString()
                : value
            }
            format={(value) =>
              value?.includes("-")
                ? new Date(value).getFullYear().toString()
                : value
            }
            validate={composeFormValidators(
              isRequired(),
              hasMaxVal(new Date().getFullYear()),
              hasMaxLength(4),
              hasMinLength(4)
            )}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <Field
              name="mainDriverSection.mainDriverData.idSerial"
              component={InputText}
              label="Serie CI/BI"
              required
              placeholder="Introdu seria"
              inputClassName={INPUT_CLASS}
              labelClass="text-sm"
              format={(value) => value?.toUpperCase()}
              validate={composeFormValidators(
                isRequired(),
                hasMinLength(2),
                hasMaxLength(2)
              )}
            />
          </div>

          <div>
            <Field
              name="mainDriverSection.mainDriverData.idNumber"
              component={InputText}
              label="Numar CI/BI"
              required
              placeholder="123456"
              inputClassName={INPUT_CLASS}
              labelClass="text-sm"
              validate={composeFormValidators(
                isRequired(),
                hasMinLength(6),
                hasMaxLength(7)
              )}
            />
          </div>
        </div>
      </div>
    )}
  </>
);

export default MainDriverSection;
